// extracted by mini-css-extract-plugin
export default {"root":"AuthHeader_root__j9p5G","sectionHeader":"AuthHeader_sectionHeader__p2FYe"};